import type { PlaceMarkerAction } from "../types/action";
import type { YinshState } from "../types/game-state";

export function applyPlaceMarker(
  state: YinshState,
  action: PlaceMarkerAction,
): YinshState {
  const newBoard = {
    ...state.board,
    [action.ringPosition]: { type: "MARKER" as const, player: action.player },
  };
  return {
    ...state,
    board: newBoard,
    markersPool: state.markersPool - 1,
    markerPlacedAt: action.ringPosition,
  };
}
